export type CounterProps = {
  label: string;
  desc: string;
  value: number;
  onChange: (v: number) => void;
  min?: number;
  max?: number;
  canIncrement?: boolean; // allow/disallow increment
  canDecrement?: boolean; // allow/disallow decrement
  testId?: string;
};

export function Counter({
  label,
  desc,
  value,
  onChange,
  min = 0,
  max = 10,
  canIncrement = true,
  canDecrement = true,
  testId,
}: Readonly<CounterProps>) {
  return (
    <div className="mb-3 flex items-center justify-between" data-testid={testId}>
      <div>
        <div className="font-[650]">{label}</div>
        <div className="text-brand-black-50 text-xs -mt-0.5">{desc}</div>
      </div>
      <div className="flex items-center gap-2">
        <button
          className="border-brand-cyan flex h-7 w-7 cursor-pointer items-center justify-center rounded-full border disabled:opacity-30"
          onClick={() => onChange(Math.max(min, value - 1))}
          disabled={value <= min || !canDecrement}
          type="button"
          data-testid={`${testId}-decrement-btn`}
        >
          <svg
            width="8"
            height="2"
            viewBox="0 0 8 2"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0.427734 0.175995H7.57173V1.82399H0.427734V0.175995Z" fill="#00AEC7" />
          </svg>
        </button>
        <span className="w-5 text-center" data-testid={`${testId}-count`}>
          {value}
        </span>
        <button
          className="border-brand-cyan flex h-7 w-7 cursor-pointer items-center justify-center rounded-full border disabled:opacity-30"
          onClick={() => onChange(Math.min(max, value + 1))}
          disabled={value >= max || !canIncrement}
          type="button"
          data-testid={`${testId}-increment-btn`}
        >
          <svg
            width="8"
            height="10"
            viewBox="0 0 8 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.7917 0.979996V4.26H7.9037V5.724H4.7917V9.02H3.1917V5.724H0.0957031V4.26H3.1917V0.979996H4.7917Z"
              fill="#00AEC7"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}
